<template lang="pug">
.k-text-chat-message(
  :class="messageClass"
)
  k-user-avatar(
    v-if="!popup && !message.sent"
    :src="message.system ? require('~images/kintell-icon-small.svg') : message.author.avatarUrl"
    :size="22"
    eager
  ).k-text-chat-message__avatar.mr-3
  .k-text-chat-message__content(
    :class="{'k-text-chat-message__content--image': message.isImage}"
    :style="{'max-height': message.isImage && Math.min(message.attributes.height, 200) + 'px', 'min-height': message.isImage && Math.min(message.attributes.height, 200) + 'px'}"
  )
    <!-- eslint-disable-next-line vue/no-v-html -->
    template
      span(v-html="body")
    <!-- show image if it is one-->
    a(
      v-if="message.isImage && mediaUrl"
      :href="mediaUrl"
      target="_blank"
    )
      v-img(
        :src="mediaUrl"
        :height="message.attributes.height"
        max-height="200"
        contain
      )
    <!-- otherwise just display filename with link to file -->
    a(
      v-else
      :href="mediaUrl"
      target="_blank"
    ) {{ message.filename }}
    div(
      v-if="message.actions && message.actions.length"
      class="k-text-chat-message__actions"
    )
      k-button(
        v-for="(action, i) in message.actions"
        :key="i"
        :disabled="isDisabled"
        :loading="getLoading(action)"
        x-small
        color="brand-pink"
        dark
        class="my-0"
        @click="action.callback.call(message, action)"
      ) {{ action.text }}
  k-user-avatar(
    v-if="!popup && message.sent && !message.system"
    :src="message.author.avatarUrl"
    :size="22"
  ).k-text-chat-message__avatar.ml-3
</template>

<script>
import md from '@/lib/markdown'

export default {
  props: {
    message: {
      type: Object,
      required: true
    },
    popup: Boolean
  },
  data () {
    return {
      // the url of media if there is any
      mediaUrl: null
    }
  },
  computed: {
    messageClass () {
      return {
        'k-text-chat-message--sent': this.message.sent,
        'k-text-chat-message--recieved': !this.message.sent && !this.message.system,
        'k-text-chat-message--system': this.message.system,
        'k-text-chat-message--actions': this.message.actions && this.message.actions.length,
        'k-text-chat-message--popup': this.popup,
      }
    },
    name () {
      const { author, system } = this.message
      return system
        ? 'Kintell'
        : `${author.firstName} ${author.lastName}`
    },
    isDisabled () {
      return typeof this.message.disabled === 'function'
        ? this.message.disabled()
        : this.message.disabled
    },
    body () {
      // sent an empty message with the file
      return this.message.body ? md.renderInline(this.message.body) : ''
    }
  },
  async mounted () {
    // resolve the promise for media url if it has been set
    if (this.message.contentUrl) {
      this.mediaUrl = await this.message.contentUrl
    }
  },
  methods: {
    getLoading (action) {
      return typeof action.loading === 'function'
        ? action.loading()
        : action.loading
    }
  }
}
</script>

<style lang="scss" scoped>
.k-text-chat-message {
  $root: &;
  display: flex;
  flex-direction: row;
  margin-top: 9px;

  &--sent {
    align-items: flex-start;
    justify-content: flex-end;
  }

  &--recieved {
    align-items: flex-start;
    justify-content: flex-start;
  }

  &__avatar {
    display: flex;
    flex-shrink: 1;
    margin-bottom: 8px;
  }

  &__content {
    border: 2px solid var(--v-brand-grey-base);
    border-radius: 15px;
    color: black;
    font-size: 13px;
    max-width: 85%;
    overflow-wrap: break-word;
    padding: 12px 15px;
    word-break: break-word;

    &--image {
      overflow: hidden;
      padding: 0 !important;
      width: 100%;
    }

    #{$root}--sent & {
      background: white;
      border-top-right-radius: 0;
    }

    #{$root}--recieved & {
      background: white;
      border-top-left-radius: 0;
    }

    #{$root}--system & {
      background: var(--v-brand-dark-blue-base);
      border: 0;
      border-top-left-radius: 0;
      color: white;
    }

    #{$root}--actions & {
      padding: 18px;
    }

    #{$root}--popup & {
      background: white;
      border-bottom-right-radius: 0;
      border-top-left-radius: 15px;
      color: inherit;
    }
  }

  &__actions {
    margin: 0 -8px; // Remove outside button margins
    padding-top: 21px;
  }
}
</style>
